export default function () {
    const urlParams = new URLSearchParams(window.location.search);
    const parsedTransactionId = parseTransactionId(urlParams.get('transaction_id'));

    const campaignId = urlParams.get('campaignId')
        ?? urlParams.get('cid')
        ?? parsedTransactionId?.campaignId;

    const publisherId = urlParams.get('publisherId')
        ?? urlParams.get('publisher_id')
        ?? urlParams.get('traffic_source')
        ?? parsedTransactionId?.publisherId;

    const clickId = parsedTransactionId?.clickId
        ?? urlParams.get('clickId')
        ?? urlParams.get('clickid')
        ?? urlParams.get('click_id')
        ?? urlParams.get('ttclid')
        ?? urlParams.get('ofreqid')
        ?? urlParams.get('pr_mbp_clickID');

    return {
        transactionId: parsedTransactionId ? urlParams.get('transaction_id') : null,
        campaignId,
        clickId,
        publisherId,
        googleClickId: urlParams.get('gclid') ?? urlParams.get('tmt_data'),
    };
}

function parseTransactionId(transactionId) {
    if (!transactionId) return null;

    const parts = transactionId.split('-');
    if (parts.length < 3) return null;

    const publisherId = parts.at(-1);
    const campaignId = parts.at(-2);
    const clickId = parts.slice(0, -2).join('-');

    if (!clickId || !campaignId || !publisherId) return null;
    if (!/^\d+$/.test(campaignId) || !/^\d+$/.test(publisherId)) return null;

    return {clickId, campaignId, publisherId};
}
